import { motion } from "framer-motion";
import {
  ShieldCheck,
  Lock,
  Globe,
  Handshake,
  UsersThree,
  ChatsTeardrop,
  Lightning,
  ArrowsHorizontal,
} from "@phosphor-icons/react";

const items = [
  { icon: ShieldCheck, title: "Professional Ethics", desc: "Strict moral standards governing every business introduction and deal we facilitate." },
  { icon: Lock, title: "Strict Confidentiality", desc: "NDA-backed handling of sensitive commercial information and partner identities." },
  { icon: Globe, title: "International Trade Expertise", desc: "Deep operational knowledge across cross-border commerce, customs and contracts." },
  { icon: Handshake, title: "Long-Term Relationships", desc: "We optimise for partnerships that compound value over years, not single transactions." },
  { icon: UsersThree, title: "Client-Centered Solutions", desc: "Every engagement is structured around the specific objectives of the client." },
  { icon: ChatsTeardrop, title: "Transparent Communication", desc: "Clear updates, written records and predictable touch-points at every stage." },
  { icon: Lightning, title: "Fast Response Time", desc: "Same-day acknowledgement and rapid escalation across regions and time-zones." },
  { icon: ArrowsHorizontal, title: "Cross-Border Support", desc: "End-to-end commercial coordination between buyers, suppliers and intermediaries." },
];

export default function TrustCredibility() {
  return (
    <section
      id="trust"
      data-testid="trust-section"
      className="py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-6">
            <span className="gold-divider" />
            <span className="overline">Trust & Credibility</span>
          </div>
          <h2 className="font-serif-display text-4xl md:text-5xl leading-[1.05] text-altin-ink tracking-tight">
            Why businesses trust{" "}
            <span className="italic text-altin-gold">Altin Link</span>.
          </h2>
          <p className="mt-6 text-lg text-altin-muted font-light max-w-2xl leading-relaxed">
            The principles, practices and standards that make us the chosen
            brokerage partner of serious international companies.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-altin-border border border-altin-border">
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <motion.div
                key={it.title}
                data-testid={`trust-card-${i}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.5, delay: (i % 4) * 0.06 }}
                className="group bg-white p-8 relative hover:bg-altin-bg transition-colors duration-300"
              >
                <div className="w-12 h-12 grid place-items-center border border-altin-gold text-altin-gold mb-6 transition-colors duration-300 group-hover:bg-altin-gold group-hover:text-white">
                  <Icon size={22} weight="light" />
                </div>
                <h3 className="font-serif-display text-xl text-altin-ink tracking-tight">
                  {it.title}
                </h3>
                <p className="mt-3 text-sm text-altin-muted leading-relaxed">
                  {it.desc}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
